import { Accordion, SectionHeading } from './ui';
import { HOME_FAQS } from './home/homeFaqs';

/**
 * Home FAQ (C15 accordion). The questions and answers are VE's existing copy;
 * Home.tsx feeds the same list to faqSchema() for the FAQ JSON-LD.
 */

export default function HomeFAQ() {
  return (
    <section className="ve-section ve-home-faq" aria-labelledby="home-faq-title" id="home-faq">
      <div className="ve-container ve-container--narrow">
        <SectionHeading eyebrow="Questions families ask" title="Frequently Asked Questions" id="home-faq-title" align="center" />
        <Accordion
          items={HOME_FAQS.map((f) => ({
            id: f.id,
            title: f.q,
            content: f.a.split('\n').map((line, j) => <p key={j}>{line}</p>),
          }))}
          defaultOpen={[HOME_FAQS[0].id]}
        />
      </div>
    </section>
  );
}
